<template>
  <div @click="showEditPopup = true" class="product" :style="bgStyle">
    <div class="overlay">
      <div
        v-if="productItem.featured || productItem.discount > 0"
        class="specials"
      >
        <span v-show="productItem.featured" class="special-item featured">{{
          "ویژه"
        }}</span>
        <span v-show="productItem.discount > 0" class="special-item discount"
          >{{ productItem.discount }}%</span
        >
      </div>
      <div class="product-details">
        <div
          class="name-cont"
          :class="!productItem.available ? 'unavailable' : ''"
        >
          <p class="name">{{ productItem.title }}</p>
        </div>
        <p v-if="productItem.price > 0" class="price">
          {{
            (+productItem.price / 10)
              .discountDistinct(productItem.discount)
              .toString()
              .numberFormat()
          }}
          تومان
        </p>
        <p
          v-if="productItem.price > 0 && productItem.discount > 0"
          class="main-price"
        >
          {{ (+productItem.price / 10).toString().numberFormat() }}
        </p>
      </div>
    </div>
    <div v-if="!product.available">
      <img
        src="../../../assets/images/unavailable.png"
        alt="unavailable"
        class="unavailable-image"
      />
    </div>
    <vs-popup
      v-if="showEditPopup"
      title="ویرایش محصول"
      :active.sync="showEditPopup"
    >
      <product-input
        v-model="productItem"
        :categories="categories"
        :activeCategory="activeCategory"
        :activeSubCategory="activeSubCategory"
        @productUpdated="productUpdated"
        @close="showEditPopup = false"
        @delete="onDelete"
      >
      </product-input>
    </vs-popup>
  </div>
</template>

<script>
  import ProductInput from "../ProductInput.vue";
  import placeholder from "../../../assets/images/placeholder.jpg";

  export default {
    name: "Product",
    components: {
      ProductInput,
    },
    data() {
      return {
        productItem: {
          ...this.product,
          featured: +this.product.featured,
        },
        showEditPopup: false,
      };
    },
    computed: {
      bgStyle() {
        return {
          backgroundImage: `url(${this.productItem.thumbnail?.url || placeholder})`,
        };
      },
    },
    watch: {
      product(newProduct) {
        this.productItem = newProduct;
      },
    },
    props: {
      product: {
        type: Object,
        required: true,
      },
      categories: {
        type: Array,
        required: true,
      },
      activeCategory: {
        type: Object,
        required: true,
      },
      activeSubCategory: {
        type: Object,
        required: false,
      },
    },
    methods: {
      productUpdated(resource, category, subCategory) {
        if (
          category.id === this.activeCategory?.id &&
          subCategory?.id === this.activeSubCategory?.id
        ) {
          this.productItem = {
            ...resource,
            featured: +resource.featured,
          };
        } else {
          this.$emit("productCategoryChanged", resource, category, {
            current: this.activeSubCategory,
            target: subCategory,
          });
        }
      },
      onDelete() {
        this.showEditPopup = false;
        this.$emit("delete");
      },
    },
  };
</script>

<style scoped lang="scss">
  .product {
    position: relative;
    border-radius: 12px;
    margin: 1px;
    height: 110px;
    width: 100%;
    max-width: var(--card-width);
    justify-self: center;
    overflow: hidden;
    cursor: pointer;
    user-select: none;
    text-align: center;
    transition: 0.3s all;
    background-position: center;
    background-size: cover;

    .overlay {
      position: relative;
      flex: 1;
      display: flex;
      height: 100%;
      background-color: #00000099;
      flex-direction: column;
      backdrop-filter: blur(1px);
    }

    img {
      display: block;
    }

    .product-details {
      padding-top: 12px;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 4px;
    }

    .name-cont {
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 80%;

      .counter-cont {
        background-color: #e0e0e0;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 20px;
        width: 20px;
        position: absolute;
        top: 5px;
        left: 5px;

        .counter {
          font-size: 13px;
          color: #232323;
          font-weight: bold;
        }
      }

      .name {
        font-size: 14px;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #fff;

        @media (max-width: 440px) {
          font-size: 12px;
          font-weight: 600;
        }
      }
    }

    .price {
      font-size: 11px;
      font-weight: 400;
      color: #ffffff;
      margin-top: 8px;
    }

    .main-price {
      font-size: 11px;
      text-decoration: line-through;
      color: #ffffff;
      font-weight: 400;
    }

    .product-image {
      height: 130px;
      object-fit: cover;
      object-position: center;
    }

    .delete-cont {
      position: absolute;
      left: 0;
      bottom: 0;
      padding: 8px;

      .delete {
        width: 16px !important;
        height: 16px !important;
        border-radius: 50%;
        padding: 10px !important;
        background-color: #c10000 !important;
      }
    }

    .specials {
      position: absolute;
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: flex-end;

      .special-item {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #c10000;
        padding: 0 5px;
        border-radius: 5px;
        box-shadow: 0 7px 24px 0 rgba(244, 67, 54, 0.4);
        color: white;
        font-size: 0.8rem;
        margin: 5px;
        height: 16px;
      }

      .featured {
        font-weight: 100;
        padding-bottom: 2px;
      }

      .discount {
        margin-left: 0;
      }
    }
  }

  .unavailable-image {
    position: absolute;
    top: 5px;
    left: -15px;
    width: 85px;
    transform: rotate(-45deg);
    z-index: 99;
    backdrop-filter: blur(0.5px);
  }
</style>
